import { collection, addDoc, getDocs, query, where, serverTimestamp } from 'firebase/firestore';
import { db } from '../../src/firebase.js';

const LS_FOLLOWERS = 'fg_fund_followers';

function readFollowers() {
    try {
        return JSON.parse(localStorage.getItem(LS_FOLLOWERS) || '{}');
    } catch {
        return {};
    }
}

function saveFollowers(data) {
    localStorage.setItem(LS_FOLLOWERS, JSON.stringify(data));
}

export async function addCampaignFollower(campaignId, email) {
    const normalized = String(email).trim().toLowerCase();
    if (!normalized || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
        throw new Error('Enter a valid email address.');
    }

    const all = readFollowers();
    const list = all[campaignId] || [];
    if (!list.includes(normalized)) {
        list.push(normalized);
        all[campaignId] = list;
        saveFollowers(all);
    }

    try {
        await addDoc(collection(db, 'fund_campaign_followers'), {
            campaignId,
            email: normalized,
            createdAt: serverTimestamp(),
        });
    } catch (err) {
        console.warn('[comingSoon] Firestore follower save failed', err);
    }
    return normalized;
}

export function mergeFollowerLists(fromId, toId) {
    if (!fromId || !toId || fromId === toId) return;
    const all = readFollowers();
    const merged = new Set([...(all[toId] || []), ...(all[fromId] || [])]);
    all[toId] = [...merged];
    delete all[fromId];
    saveFollowers(all);
}

export async function getCampaignFollowers(campaignId) {
    const local = readFollowers()[campaignId] || [];
    try {
        const snap = await getDocs(
            query(collection(db, 'fund_campaign_followers'), where('campaignId', '==', campaignId))
        );
        const emails = new Set(local);
        snap.docs.forEach((d) => emails.add(d.data().email));
        return [...emails];
    } catch {
        return local;
    }
}
